<app-slider *ngIf="!preferenceService.cargando"
            [preferences]="this.preferenceService.preferences"
            [selectedDepartmentId]="departmentId"
>
</app-slider>
<mat-spinner class="spinner" *ngIf="loading || preferenceService.cargando">
</mat-spinner>
<app-special-products *ngIf="!loading || preferenceService.cargando"
                      [products]="articles"
                      [cantpages]="pages"
                      [page]="filter.page"
                      [loading]="loading"
                      (nextPage)="onNext()"
                      (previous)="onPrev()"
></app-special-products>
